import { AccountInfo } from '@azure/msal-browser';

export type AuthMode = 'b2c' | 'entra';

export interface AuthState {
  isInitialized: boolean;
  isAuthenticated: boolean;
  mode: AuthMode | null;
  account: AccountInfo | null;
  token: string | null;
  error: Error | null;
  tokenRefreshError: boolean;
}

export interface AuthContextValue extends AuthState {
  refreshToken: () => Promise<string>;
  logout: () => Promise<void>;
}

export interface ClientConfiguration {
  adClientId: string;
  admin360Url: string;
  adScopes: string;
  adTenantId: string;
  adTenantName: string;
  apiClientId: string;
  apiEndpoint: string;
  apiRingCentralClientId: string;
  appInsightsConnectionString: string;
  authority: string;
  b2cPolicy: string;
  clientId: string;
  customDomain: string;
  domainHint: string;
  helixAppClientId: string;
  redirectUrl: string;
  scopes: string;
  tenantName: string;
  supportResponseTime: string
}

export class TokenRefreshError extends Error {
  constructor(message: string, public readonly cause?: any) {
    super(message);
    this.name = 'TokenRefreshError';
  }
}

export interface AuthService {
  initialize(config: ClientConfiguration): Promise<void>;
  acquireToken(account: AccountInfo): Promise<string>;
  logout(): Promise<void>;
  getAllAccounts(): AccountInfo[];
}
